module.exports = __webpack_public_path__ + "static/media/7.18.4a1be838.png";